import axios from '../../../axios';
import API from '../../../actions/api';
import { stripePaymentService } from '../../../services/stripeService';
import {
  getPaymentsLoading,
  getPaymentsSuccess,
  getPaymentsFailed,
  checkoutLoading,
  checkoutFailed,
  checkoutRedirecting,
  verifyLoading,
  verifySuccess,
  verifyFailed,
} from './paymentSlice';

const paymentsUrl = API + '/dashboard/payments';

/**
 * Fetch the authenticated user's payment history.
 */
export const getPaymentsThunk = () => async (dispatch) => {
  try {
    dispatch(getPaymentsLoading());
    const { data } = await axios.get(paymentsUrl);
    dispatch(getPaymentsSuccess(data));
  } catch {
    dispatch(getPaymentsFailed());
  }
};

/**
 * Create a Stripe hosted Checkout Session and redirect the user to Stripe's
 * hosted payment page.
 *
 * The backend creates the session and returns a checkout_url.
 * We then do a full-page redirect — the user enters card details on
 * Stripe's site, never on ours.
 *
 * After payment, Stripe redirects back to /payment-success?session_id=cs_xxx.
 *
 * @param {string} subscriptionType  "month" | "year"
 * @param {number} amount            Per-unit price (e.g. 2.00 for €2/month)
 * @param {number} duration          Number of months or years
 */
export const initiateStripeCheckoutThunk =
  (subscriptionType, amount, duration) => async (dispatch) => {
    try {
      dispatch(checkoutLoading());
      const data = await stripePaymentService.createCheckoutSession(
        subscriptionType,
        amount,
        duration
      );
      // Mark loading as done before leaving the page
      dispatch(checkoutRedirecting());
      // Full-page redirect to Stripe's hosted checkout
      window.location.href = data.checkout_url;
    } catch (error) {
      const message = error?.error || 'Failed to initiate payment. Please try again.';
      dispatch(checkoutFailed(message));
    }
  };

/**
 * Verify a completed Checkout Session after Stripe redirects the user back.
 *
 * Called on the /payment-success page with the session_id from the URL
 * query string (?session_id=cs_xxx).
 *
 * @param {string} sessionId  Stripe session ID (cs_xxx)
 */
export const verifyStripeSessionThunk = (sessionId) => async (dispatch) => {
  try {
    dispatch(verifyLoading());
    await stripePaymentService.verifyCheckoutSession(sessionId);
    dispatch(verifySuccess());
  } catch (error) {
    const message = error?.error || 'Payment verification failed. Please contact support.';
    dispatch(verifyFailed(message));
  }
};
